import { render, staticRenderFns } from "./MetadataSavingPopup.vue?vue&type=template&id=f27ad8ca&scoped=true"
import script from "./MetadataSavingPopup.vue?vue&type=script&lang=js"
export * from "./MetadataSavingPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27ad8ca",
  null
  
)

export default component.exports